// @owners { team: patient-health }
import { getDeliveriesForPrescriptionID } from '~shared/features/delivery/selectors/getDeliveriesForPrescriptionID';
import getLoading from '~shared/features/ui/selectors/getLoading';
import { sendAnalyticsEvent } from '~shared/lib/analytics/src/actions';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import MedListPrice, { type Props } from './MedListPrice';

const mapStateToProps = (state: ReduxStateShared, ownProps: Props) => {
  const { prescription } = ownProps;
  const { fetchPrescriptionPricingLoading: priceLoading } = getLoading(state);
  const deliveries = getDeliveriesForPrescriptionID(state, {
    prescriptionID: prescription?.id,
  });
  const deliveryID = deliveries?.length ? deliveries.map((d) => d.id)[0] : undefined;

  return {
    priceLoading,
    deliveryID,
  };
};

const mapDispatchToProps = {
  sendAnalyticsEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(MedListPrice);
